import * as React from 'react';
import { translate } from 'react-i18next';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import * as c from 'models/constants';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { EllipseBlackWhiteButton } from 'components/Common/Button';
import { browserHistory } from 'react-router';
import renderIcon from 'helpers/renderIcon';
import { default as Slider } from 'react-slick';

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
}

interface IState {
	maxElWidth: number;
}

function CustomSlickArrow(props) {
	const { classToAdd, onClick, children } = props;
	return (
		<div className={'slick-arrow ' + classToAdd} onClick={onClick}>
			{children}
		</div>
	);
}

let oldWidth = 1400;

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType5 extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			maxElWidth: null,
		};
		this.setMaxElWidth = this.setMaxElWidth.bind(this);
	}
	sectionRef = React.createRef<HTMLDivElement>();

	componentDidMount(): void {
		this.setMaxElWidth();
		window.addEventListener('resize', this.setMaxElWidth);
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.setMaxElWidth);
	}

	private setMaxElWidth() {
		const section = this.sectionRef.current;
		if (section) {
			const sectionWidth = section.getBoundingClientRect().width;
			const clientWidth = document?.documentElement?.clientWidth;
			if (clientWidth) {
				// shrinking
				if (sectionWidth >= clientWidth - 30 && oldWidth > clientWidth - 30) {
					this.setState({
						maxElWidth: clientWidth && clientWidth <= 1400 ? clientWidth - 30 : 1400,
					});
					oldWidth = clientWidth - 30;
					return;
				}
				// expanding
				if (sectionWidth <= clientWidth - 30 && oldWidth < clientWidth - 30) {
					this.setState({
						maxElWidth: clientWidth && clientWidth <= 1400 ? clientWidth - 30 : 1400,
					});
					oldWidth = clientWidth - 30;
					return;
				}
				// initial
				this.setState({
					maxElWidth: clientWidth - 30 < 1400 ? clientWidth - 30 : 1400,
				});
				oldWidth = clientWidth - 30;

				// Sets arrows top position
				// Reson: Signle hero slider changes layout at 700px breakpoint. Without this, the arrows would be
				// in the centre of the slide and not in the cetre of the image
				if (oldWidth <= 700) {
					const imageElements = document.querySelectorAll('div.portalPageSectionType5.single .image-container');
					const sliderArrows = document.querySelectorAll('div.portalPageSectionType5.single .slick-arrow');
					if (imageElements.length && sliderArrows.length) {
						imageElements.forEach((x) => {
							const height = x.getBoundingClientRect().height;
							sliderArrows.forEach((y) => {
								y.setAttribute('style', `top:${height / 2}px;transform:translateY(-50%);`);
							});
						});
					}
					// remove styles above 700px width
				} else {
					const sliderArrows = document.querySelectorAll('div.portalPageSectionType5.single .slick-arrow');
					if (sliderArrows.length) {
						sliderArrows.forEach((y) => {
							y.setAttribute('style', ``);
						});
					}
				}
			}
		}
	}

	public render() {
		const { section } = this.props;

		const handleNavigate = (redirectUrl: string) => {
			const extractedPath = new URL(redirectUrl).pathname;
			browserHistory.push(extractedPath);
		};
		///////////////////////////////////////////////////
		// Slider settings
		///////////////////////////////////////////////////
		const settings = {
			dots: false,
			infinite: true,
			speed: 674,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: <CustomSlickArrow classToAdd="slick-prev">{renderIcon('left')}</CustomSlickArrow>,
			nextArrow: <CustomSlickArrow classToAdd="slick-next">{renderIcon('right')}</CustomSlickArrow>,
			autoplay: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
		};

		const renderElements = () => {
			let imageUrl = '';
			let title = '';
			let subTitle = '';
			let buttonText = '';
			const redirectUrl = {
				1: '',
				2: '',
				3: '',
				4: '',
			};
			let label = '';
			///////////////////////////////////////////////////
			// SingleHero
			///////////////////////////////////////////////////
			if ((section.items[0].elements[1] as ISectionTextElement).subText) {
				return (
					<Slider {...settings}>
						{section.items.map((x, index) => {
							const itemImageUrl = (x.elements[0] as ISectionImageElement).imageUrl;
							imageUrl = itemImageUrl ? itemImageUrl : '';

							const item = x.elements[1] as ISectionTextElement;
							const itemTitle = item?.text;
							const itemSubTitle = item?.subText;
							const itemButtonText = item?.buttonText;
							const itemRedirectUrl = item?.redirectUrl;
							title = itemTitle ? itemTitle : '';
							subTitle = itemSubTitle ? itemSubTitle : '';
							buttonText = itemButtonText ? itemButtonText : '';
							redirectUrl[index] = itemRedirectUrl ? itemRedirectUrl : '';

							return (
								<div key={index}>
									<div>
										<div className="text-container">
											<div className="text">
												<h1>{title}</h1>
												<p>{subTitle}</p>
												<EllipseBlackWhiteButton onClick={() => handleNavigate(redirectUrl[index])}>
													{buttonText}
												</EllipseBlackWhiteButton>
											</div>
										</div>
										<div className="image-container">
											<img className="image" src={imageUrl} />
										</div>
									</div>
								</div>
							);
						})}
					</Slider>
				);
				///////////////////////////////////////////////////
				// DoubleHero
				///////////////////////////////////////////////////
			} else {
				const elementsToRender: JSX.Element[] = [];
				section.items.forEach((x, index) => {
					const itemImageUrl = (x.elements[0] as ISectionImageElement).imageUrl;
					imageUrl = itemImageUrl ? itemImageUrl : '';

					const item = x.elements[1] as ISectionTextElement;
					const itemLabel = item?.label;
					const itemTitle = item?.text;
					const itemButtonText = item?.buttonText;
					const itemRedirectUrl = item?.redirectUrl;
					label = itemLabel ? itemLabel : '';
					title = itemTitle ? itemTitle : '';
					buttonText = itemButtonText ? itemButtonText : '';
					redirectUrl[index] = itemRedirectUrl ? itemRedirectUrl : '';

					elementsToRender.push(
						<div key={index} style={{ backgroundImage: `url(${imageUrl})` }}>
							<div className="gradientBottomToTop" />
							{label.length ? (
								<div className="label">
									<p className="p12 white">{label.toUpperCase()}</p>
								</div>
							) : null}
							<div className="text-container">
								<div className="text">
									<h1>{title}</h1>
									<EllipseBlackWhiteButton onClick={() => handleNavigate(redirectUrl[index])}>
										{buttonText}
									</EllipseBlackWhiteButton>
								</div>
							</div>
						</div>,
					);
				});
				return <div className="doubleHero">{elementsToRender}</div>;
			}
		};

		return (
			<div className="row">
				<div className="col-lg-12 d-flex justify-content-center">
					<div
						className={`portalPageSectionType5 ${
							(section.items[0].elements[1] as ISectionTextElement).subText ? 'single' : 'double'
						}`}
						style={{ maxWidth: this.state.maxElWidth ? this.state.maxElWidth : 'auto' }}
						ref={this.sectionRef}
					>
						{renderElements()}
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType5 };
